/**
 * A contact detail value at body weight.
 *
 * `Field` / `FactTile` render plain-string values at `font-medium`, which is
 * right for short metadata (a status, a date) but made a block of emails,
 * phone numbers and addresses read as one heavy slab. Contact details are
 * passed through this instead: same size and colour family, normal weight,
 * and long addresses or emails wrap rather than overflow.
 *
 * Returns null for an empty value so the host primitive still renders its
 * muted "Not set".
 */

import React from 'react';

export const contactValue = (value?: string | null): React.ReactNode =>
  value ? (
    <p className="text-sm font-normal text-fg-body break-words whitespace-pre-line">{value}</p>
  ) : null;

export default contactValue;
